import React, { useRef, useState, useEffect } from "react";
import JoditEditor from "jodit-react";

function StandaloneRichText(props) {
  const { name, label, validation, indent = "false", value, onChange } = props;
  const editor = useRef(null);

  const safeValue = typeof value === "string" ? value : "";
  const [content, setContent] = useState(safeValue);

  useEffect(() => {
    const incoming = typeof value === "string" ? value : "";
    if (incoming !== content) {
      setContent(incoming);
    }
  }, [value]);

  const handleChange = (newContent) => {
    const safeContent = typeof newContent === "string" ? newContent : "";
    setContent(safeContent);
    if (safeContent !== value && onChange) {
      onChange(safeContent);
    }
  };

  const isIndentYes = (indent || "").toString().toLowerCase() === "yes";

  return (
    // <>
    //   {label && (
    //     <label
    //       className={`${
    //         isIndentYes ? "ml-7" : ""
    //       } text-sm font-normal inline-block text-custom-gray-400`}
    //       htmlFor={name}
    //     >
    //       {label}{" "}
    //       {validation?.required == true && (
    //         <span className="text-sm text-asterisk-red">&#42;</span>
    //       )}
    //     </label>
    //   )}

    //   <div className="relative border border-gray-400 p-4 pb-9">
    //     <JoditEditor ref={editor} value={content} onChange={handleChange} />
    //   </div>
    // </>
    <JoditEditor ref={editor} value={content} onChange={handleChange} />
  );
}

export default StandaloneRichText;